import { DataLayerService } from '@pulse/browser-shared';
import { Observable, Subject } from 'rxjs';
import { SettingsResponse } from '../models';

export class ResponseTrackerService {
    private responses$ = new Subject<SettingsResponse>();
    constructor(private dataLayerService: DataLayerService) {}

    responses(): Observable<SettingsResponse> {
        return this.responses$.asObservable();
    }

    trackResponse(response: SettingsResponse): SettingsResponse {
        this.responses$.next(response);

        const experiments = response.experiments?.filter((experiment) => experiment?.trackable);
        const data: any = {
            pulse: 'state',
            segments: response.segments,
        };

        if (experiments) {
            data.experiments = experiments;
        }

        this.dataLayerService.pushData(data);

        return response;
    }
}
